import React from 'react';
import styled from 'styled-components';
import LegalPersonDocumentsContentComponent from 'components/renter_application/legal_person/DocumentsContentComponent';
import LegalPersonEarningsContentComponent from 'components/renter_application/legal_person/EarningsContentComponent';
import LegalPersonProfileContentComponent from 'components/renter_application/legal_person/ProfileContentComponent';
import LegalPersonReferencesContentComponent from 'components/renter_application/legal_person/ReferencesContentComponent';
import PaymentContent from 'components/renter_application/PaymentContentComponent';

import HomeApplication from 'models/HomeApplication';

import { LEGAL_PERSON } from 'utils/Constants';

import { StepperContent } from 'styles/Steppers';

const ProfileStepper = styled(StepperContent)`
  padding: 0;
`;

type PropsType = {
  homeApplication: HomeApplication,
  langSelected: string,
  typePersonSelected: number,
  visibleFormBill: boolean,
  onHomeApplicationChange: () => void,
  onHomeApplicationCancel: () => void,
  isTheStepVisible: (number, number | null, boolean | null) => boolean,
  onNextStep: () => void,
  onPrevStep: () => void,
  prevStepText: string,
  isOnlyEditIncome: boolean
};

class LegalPersonHomeApplication extends React.Component<PropsType> {
  render() {
    const {
      homeApplication,
      langSelected,
      typePersonSelected,
      visibleFormBill,
      onHomeApplicationChange,
      onHomeApplicationCancel,
      isTheStepVisible,
      onNextStep,
      onPrevStep,
      prevStepText,
      isOnlyEditIncome
    } = this.props;

    return (
      <div>
        {isTheStepVisible(1, LEGAL_PERSON) && (
          <ProfileStepper>
            <LegalPersonProfileContentComponent
              homeApplication={homeApplication}
              onChange={onHomeApplicationChange}
              onCancel={onHomeApplicationCancel}
              onPrevStep={onPrevStep}
            />
          </ProfileStepper>
        )}
        {isTheStepVisible(2, LEGAL_PERSON) && (
          <StepperContent>
            <LegalPersonEarningsContentComponent
              homeApplication={homeApplication}
              onChange={onHomeApplicationChange}
              onCancel={onHomeApplicationCancel}
              onPrevStep={onPrevStep}
              isOnlyEditIncome={isOnlyEditIncome}
            />
          </StepperContent>
        )}
        {isTheStepVisible(3, LEGAL_PERSON) && (
          <StepperContent>
            <LegalPersonReferencesContentComponent
              homeApplication={homeApplication}
              onChange={onHomeApplicationChange}
              onCancel={onHomeApplicationCancel}
              onPrevStep={onPrevStep}
            />
          </StepperContent>
        )}
        {isTheStepVisible(4, LEGAL_PERSON) && (
          <StepperContent>
            <LegalPersonDocumentsContentComponent
              homeApplication={homeApplication}
              onChange={onHomeApplicationChange}
              onCancel={onHomeApplicationCancel}
              onPrevStep={onPrevStep}
            />
          </StepperContent>
        )}
        {isTheStepVisible(5, LEGAL_PERSON) && (
          <StepperContent>
            <PaymentContent
              onChange={onHomeApplicationChange}
              onCancel={onHomeApplicationCancel}
              langSelected={langSelected}
              typePersonSelected={typePersonSelected}
              nextAction={onNextStep}
              visibleFormBill={visibleFormBill}
              onPrevStep={onPrevStep}
              homeAppData={homeApplication}
              prevStepText={prevStepText}
            />
          </StepperContent>
        )}
      </div>
    );
  }
}

export default LegalPersonHomeApplication;
